/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * |Token | Name | Dimensions|
 *
 * @remarks
 * |:---|:---|:---|
 * | UPS_Box_10kg | Box 10kg | 410.00 x 335.00 x 265.00 mm|
 * | UPS_Box_25kg | Box 25kg | 484.00 x 433.00 x 350.00 mm|
 * | UPS_Express_Box | Express Box | 460.00 x 315.00 x 95.00 mm|
 * | UPS_Express_Box_Large | Express Box Large | 18.00 x 13.00 x 3.00 in|
 * | UPS_Express_Box_Medium | Express Box Medium | 15.00 x 11.00 x 3.00 in|
 * | UPS_Express_Box_Small | Express Box Small | 13.00 x 11.00 x 2.00 in|
 * | UPS_Express_Envelope | Express Envelope | 12.50 x 9.50 x 2.00 in|
 * | UPS_Express_Hard_Pak | Express Hard Pak | 14.75 x 11.50 x 2.00 in|
 * | UPS_Express_Legal_Envelope | Express Legal Envelope | 15.00 x 9.50 x 2.00 in|
 * | UPS_Express_Pak | Express Pak | 16.00 x 12.75 x 2.00 in|
 * | UPS_Express_Tube | Express Tube | 970.00 x 190.00 x 165.00 mm|
 * | UPS_Laboratory_Pak | Laboratory Pak | 17.25 x 12.75 x 2.00 in|
 * | UPS_MI_BPM | BPM (Mail Innovations - Domestic &amp; International) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_BPM_Flat | BPM Flat (Mail Innovations - Domestic &amp; International) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_BPM_Parcel | BPM Parcel (Mail Innovations - Domestic &amp; International) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_First_Class | First Class (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Flat | Flat (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Irregular | Irregular (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Machinable | Machinable (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_MEDIA_MAIL | Media Mail (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Parcel_Post | Parcel Post (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Priority | Priority (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Standard_Flat | Standard Flat (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_Pad_Pak | Pad Pak | 14.75 x 11.00 x 2.00 in|
 * | UPS_Pallet | Pallet | 120.00 x 80.00 x 200.00 cm|
 */
export const ParcelTemplateUPSEnum = {
  UPSBox10kg: "UPS_Box_10kg",
  UPSBox25kg: "UPS_Box_25kg",
  UPSExpressBox: "UPS_Express_Box",
  UPSExpressBoxLarge: "UPS_Express_Box_Large",
  UPSExpressBoxMedium: "UPS_Express_Box_Medium",
  UPSExpressBoxSmall: "UPS_Express_Box_Small",
  UPSExpressEnvelope: "UPS_Express_Envelope",
  UPSExpressHardPak: "UPS_Express_Hard_Pak",
  UPSExpressLegalEnvelope: "UPS_Express_Legal_Envelope",
  UPSExpressPak: "UPS_Express_Pak",
  UPSExpressTube: "UPS_Express_Tube",
  UPSLaboratoryPak: "UPS_Laboratory_Pak",
  UpsMiBpm: "UPS_MI_BPM",
  UPSMIBPMFlat: "UPS_MI_BPM_Flat",
  UPSMIBPMParcel: "UPS_MI_BPM_Parcel",
  UPSMIFirstClass: "UPS_MI_First_Class",
  UPSMIFlat: "UPS_MI_Flat",
  UPSMIIrregular: "UPS_MI_Irregular",
  UPSMIMachinable: "UPS_MI_Machinable",
  UpsMiMediaMail: "UPS_MI_MEDIA_MAIL",
  UPSMIParcelPost: "UPS_MI_Parcel_Post",
  UPSMIPriority: "UPS_MI_Priority",
  UPSMIStandardFlat: "UPS_MI_Standard_Flat",
  UPSPadPak: "UPS_Pad_Pak",
  UPSPallet: "UPS_Pallet",
} as const;
/**
 * |Token | Name | Dimensions|
 *
 * @remarks
 * |:---|:---|:---|
 * | UPS_Box_10kg | Box 10kg | 410.00 x 335.00 x 265.00 mm|
 * | UPS_Box_25kg | Box 25kg | 484.00 x 433.00 x 350.00 mm|
 * | UPS_Express_Box | Express Box | 460.00 x 315.00 x 95.00 mm|
 * | UPS_Express_Box_Large | Express Box Large | 18.00 x 13.00 x 3.00 in|
 * | UPS_Express_Box_Medium | Express Box Medium | 15.00 x 11.00 x 3.00 in|
 * | UPS_Express_Box_Small | Express Box Small | 13.00 x 11.00 x 2.00 in|
 * | UPS_Express_Envelope | Express Envelope | 12.50 x 9.50 x 2.00 in|
 * | UPS_Express_Hard_Pak | Express Hard Pak | 14.75 x 11.50 x 2.00 in|
 * | UPS_Express_Legal_Envelope | Express Legal Envelope | 15.00 x 9.50 x 2.00 in|
 * | UPS_Express_Pak | Express Pak | 16.00 x 12.75 x 2.00 in|
 * | UPS_Express_Tube | Express Tube | 970.00 x 190.00 x 165.00 mm|
 * | UPS_Laboratory_Pak | Laboratory Pak | 17.25 x 12.75 x 2.00 in|
 * | UPS_MI_BPM | BPM (Mail Innovations - Domestic &amp; International) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_BPM_Flat | BPM Flat (Mail Innovations - Domestic &amp; International) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_BPM_Parcel | BPM Parcel (Mail Innovations - Domestic &amp; International) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_First_Class | First Class (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Flat | Flat (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Irregular | Irregular (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Machinable | Machinable (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_MEDIA_MAIL | Media Mail (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Parcel_Post | Parcel Post (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Priority | Priority (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_MI_Standard_Flat | Standard Flat (Mail Innovations - Domestic only) | 0.00 x 0.00 x 0.00 in|
 * | UPS_Pad_Pak | Pad Pak | 14.75 x 11.00 x 2.00 in|
 * | UPS_Pallet | Pallet | 120.00 x 80.00 x 200.00 cm|
 */
export type ParcelTemplateUPSEnum = ClosedEnum<typeof ParcelTemplateUPSEnum>;

/** @internal */
export const ParcelTemplateUPSEnum$inboundSchema: z.ZodNativeEnum<
  typeof ParcelTemplateUPSEnum
> = z.nativeEnum(ParcelTemplateUPSEnum);

/** @internal */
export const ParcelTemplateUPSEnum$outboundSchema: z.ZodNativeEnum<
  typeof ParcelTemplateUPSEnum
> = ParcelTemplateUPSEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ParcelTemplateUPSEnum$ {
  /** @deprecated use `ParcelTemplateUPSEnum$inboundSchema` instead. */
  export const inboundSchema = ParcelTemplateUPSEnum$inboundSchema;
  /** @deprecated use `ParcelTemplateUPSEnum$outboundSchema` instead. */
  export const outboundSchema = ParcelTemplateUPSEnum$outboundSchema;
}
